import { trpc } from '@/shared/api/trpc';

type UseSearchAccountsByNameOptions = {
  enabled?: boolean;
  limit?: number;
};

export const useSearchAccountsByName = (
  name: string,
  { enabled = true, limit = 20 }: UseSearchAccountsByNameOptions = {}
) =>
  trpc.accounts.searchByName.useQuery(
    { name, limit },
    { enabled: enabled && name.trim().length > 0 }
  );
